define('lib/validator/Validator',['require','marionette','underscore'],function (require) {

	var Marionette = require('marionette');
	var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
	
	return Marionette.Object.extend({
		
		_validators: [],
		_errors: [],
		
		/**
		 * Init instance
		 */
		initialize: function (options) {
			this._validators = [];
			if (this.getOption('validators')) {
				_.each(this.getOption('validators'), function (validator) {
					this.addValidator(validator);
				}, this);
			}
		},
		
		/**
		 * Adds validator
		 * 
		 * @param ValidatorAbstract validator
		 */
		addValidator: function (validator) {
			this._validators.push(validator);
		},
		
		/**
		 * Validate value
		 * 
		 * @param mixed value
		 * @return Boolean
		 */
		isValid: function (value) {
			this._errors = [];
			_.each(this._validators, function (validator) {
				if (!validator.isValid(value)) {
					this._errors = _.union(this._errors, validator.getErrors());
				}
			}, this);
			if (this._errors.length) {
				return false;
			}
			return true;
		},
		
		/**
		 * Returns errors array
		 * 
		 * @return Array
		 */
		getErrors: function () {
			return this._errors;
		}
		
	});
	
});
